/**
 *  @file: index.js is a <js> file
 *  @date: File created 2020-11-09 21:05
 *  @author:  shangwenhe
 */
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  // {
  //   path: '*',
  //   redirect: '/java_basic_sem_search.html'
  // },
  {
    path: '/data_analysis.html',
    component: () => import('../pages/data-analysis/page/index'),
    meta: {
      title: '数据分析实战训练营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/analysis_promote.html',
    component: () => import('../pages/data-analysis-middle/page/index'),
    meta: {
      title: '数据分析能力提升特训营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/data_enhancement.html',
    component: () => import('../pages/big-data/page/index'),
    meta: {
      title: '大数据开发训练营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/java_architect.html',
    component: () => import('../pages/study-system/page/index'),
    meta: {
      title: 'Java工程师高薪训练营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/java_basic.html',
    component: () => import('../pages/java-base-class/page/index'),
    meta: {
      title: 'Java就业急训营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/fe_essential.html',
    component: () => import('../pages/frontend-sem/page/index'),
    meta: {
      title: '大前端就业急训营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/fe_enhancement.html',
    component: () => import('../pages/frontend/page/index'),
    meta: {
      title: '大前端高薪训练营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/pm__enhancement.html',
    component: () => import('../pages/ProductM/page/index'),
    meta: {
      title: '产品经理高薪训练营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/python.html',
    component: () => import('../pages/python/page/index'),
    meta: {
      title: 'Python实战全能班-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/AI.html',
    component: () => import('../pages/AI/page/index'),
    meta: {
      title: 'AI人工智能训练营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/operations.html',
    component: () => import('../pages/operations/page/index'),
    meta: {
      title: 'Linux 运维实战训练营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/offer.html',
    component: () => import('../pages/offer/pages/index'),
    meta: {
      title: '大厂 Offer 私教计划-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/test_engineer.html',
    component: () => import('../pages/test-engineer/page/index'),
    meta: {
      title: '自动化测试名企直推营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/ux_design.html',
    component: () => import('../pages/ux_design/page/index'),
    meta: {
      title: '大厂 UIUX 设计进阶训练营 - 拉勾教育-拉勾旗下职业教育平台',
    }
  },
  //    sem 前端高薪 大数据 java
  {
    path: '/web_basic_sem_search.html',
    component: () => import('../pages/frontend-sem/page/search'),
    meta: {
      title: '大前端高薪训练营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/data_basic_sem_search.html',
    component: () => import('../pages/big-data-sem/pages/index'),
    meta: {
      title: '大数据高薪训练营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/java_basic_sem_search.html',
    component: () => import('../pages/java-camp/pages/index'),
    meta: {
      title: 'Java急训营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/pp_basic_sem_search.html',
    component: () => import('../pages/web-data/page/index'),
    meta: {
      title: '编程培训-拉勾教育-拉勾旗下互联网教育平台',
    }
  },
  {
    path: '/PMP.html',
    component: () => import('../pages/PMP-view/page/index'),
    meta: {
      title: 'PMP®考前授权特训营-拉勾教育-升职加薪就上拉勾教育',
    }
  },
  {
    path: '/pm__0basic.html',
    component: () => import('../pages/pm__0basic/page/index'),
    meta: {
      title: '产品经理能力创造营-大厂私教计划-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/all_operate.html',
    component: () => import('../pages/manager/page/index'),
    meta: {
      title: '全栈运营实操训练营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/fe-project-camp.html',
    component: () => import('../pages/frontend-mid-price/page/index'),
    meta: {
      title: 'P7 明星项目冲刺计划-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/fe-next.html',
    component: () => import('../pages/frontend-private/page/index'),
    meta: {
      title: '前端高薪 NEXT 计划｜定制未来-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/interview-card.html',
    component: () => import('../pages/interview-card/page/index.vue'),
    meta: {
      title: '大厂能力诊断卡-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/imitate-interview.html',
    component: () => import('../pages/imitate-interview/page/index.vue'),
    meta: {
      title: '面试卡-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/imitate-interview-oth.html',
    component: () => import('../pages/imitate-interview-oth/page/index.vue'),
    meta: {
      title: '内推卡-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/unregister.html',
    component: () => import('../pages/unregister/page/index.vue'),
    meta: {
      title: '注销账号须知',
    }
  },
  {
    path: '/interpolate.html',
    component: () => import('../pages/interpolate/page/index.vue'),
    meta: {
      title: '拉勾求职帮帮团，帮你内推“走后门”！',
    }
  },
  {
    path: '/community.html',
    component: () => import('../pages/community/page/index.vue'),
    meta: {
      title: '大厂内推-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/pass-plan.html',
    component: () => import('../pages/pass-plan/page/index.vue'),
    meta: {
      title: '大厂内推-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/day-live.html',
    component: () => import('../pages/day-live/page/index.vue'),
    meta: {
      title: '大厂内推-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/confession.html',
    component: () => import('../pages/confession/page/index.vue'),
    meta: {
      title: '【5月告白季，超值优惠助力涨薪】-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/confessionInvite.html',
    component: () => import('../pages/confession/page/indexInvite.vue'),
    meta: {
      title: '【5月告白季，超值优惠助力涨薪】-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/subsidies.html',
    component: () => import('../pages/subsidies/page/index.vue'),
    meta: {
      title: '618百万补贴，年中钜惠嗨学一夏-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/doc.html',
    component: () => import('../pages/doc/page/index.vue'),
    meta: {
      title: '训练营服务协议',
    }
  },
  {
    path: '/page69.html',
    component: () => import('../pages/page69/page/index.vue'),
    meta: {
      title: '618百万补贴，年中钜惠嗨学一夏-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/page618.html',
    component: () => import('../pages/page618/page/index.vue'),
    meta: {
      title: '618百万补贴，年中钜惠嗨学一夏-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/open-miniprogram.html',
    component: () => import('../pages/open-miniprogram/page/index.vue'),
    meta: {
      title: '打开小程序',
    }
  },
  {
    path: '/page618-back.html',
    component: () => import('../pages/page618-back/page/index.vue'),
    meta: {
      title: '618百万补贴，年中钜惠嗨学一夏-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/doc2.html',
    component: () => import('../pages/doc2/page/index.vue'),
    meta: {
      title: '外包脱坑特训营服务协议',
    }
  },
  {
    path: '/doc3.html',
    component: () => import('../pages/doc3/page/index.vue'),
    meta: {
      title: '风变MTP购课协议',
    }
  },
  {
    path: '/business.html',
    component: () => import('../pages/business/page/index'),
    meta: {
      title: '商业数据分析高薪实战营-拉勾教育-拉勾旗下职业教育平台',
    }
  },
  {
    path: '/doc4.html',
    component: () => import('../pages/doc4/page/index.vue'),
    meta: {
      title: '测吧购课协议',
    }
  },
  // {
  //   path: '/work_essential.html',
  //   component: () => import('../pages/work.vue'),
  //   meta: {
  //     title: '职场',
  //   }
  // },
  // {
  //   path: '/whole_link.html',
  //   component: () => import('../pages/link.vue'),
  //   meta: {
  //     title: '设计全链路',
  //   }
  // },
  // {
  //   path: '/ux_design.html',
  //   component: () => import('../pages/ux.vue'),
  //   meta: {
  //     title: 'UX',
  //   }
  // },
  // {
  //   path: '/pm_essential.html',
  //   component: () => import('../pages/pm.vue'),
  //   meta: {
  //     title: '产品',
  //   }
  // },
];

export default new VueRouter({
  mode: "history",
  base: "/growth/sem",
  routes,
});
